import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next'; 

import React, { Component } from 'react'
import { Link, Image, RichText } from '@sitecore-jss/sitecore-jss-react';

import '../../assets/css/0020_objects/0790_obj_push_comptoir_dermato_espace_formation.css'
import '../../assets/css/0020_objects/0710_obj_carousel_formation.css';

class ObjPushComptoirDermatoEspaceFormation extends Component {
	render() {
        const { datasPage } = this.props;

        return (<>{datasPage && <>
			<div className="obj_push_comptoir_dermato_espace_formation">

				<div className="obj_image">
					<picture className="ctn_image fade-in">
                        <Image media={datasPage["Comptoir Dermato image"]?.value}/>
                        <Image media={datasPage["Comptoir Dermato logo"]?.value} className="image_logo"/>
					</picture>
				</div>
				<div className="ctn_text">
                    <h3 className="t_title"><RichText field={datasPage["Comptoir Dermato text"]}/></h3>
                    <div className="ctn_cta">
						<Link className="obj_cta-txt" field={datasPage["Comptoir Dermato Url"]?.value}/>
					</div>
				</div>

			</div>
        </>}</>)
	}

}

export default withTranslation()(withSitecoreContext()(ObjPushComptoirDermatoEspaceFormation));